import React from 'react';

const ItemInfo = ({ name, productId }) => (<div className="fs16 fw700 padding-b15 padding-t0" style={{ color: '#2ca8d2', letterSpacing: '0.7px' }}>{name}, Product Id : {productId}</div>);

export default ItemInfo;
